import {default as LogReportV} from "./LogReport";

import {default as Table} from "../AdvTableForReport";

import {connect} from "react-redux";
import {actions} from "./logic/logReportActions";
import {REPORT_TYPE} from "../common";
import {default as AdvMessage} from "../ReportMessage";
import {get} from "lodash";


export const LogReport =  connect(
    (state) => ({
        advertisersCount: state.reportLog.advertisersCount,
        filmReleases: state.reportLog.filmReleases,
        loadingStatus: state.reportLog.loadingStatus,
        advertisementTypes: state.reportLog.advertisementTypes,
        showComments: state.reportLog.showComments
    }) , (dispatch) => ({
        onLoadReportView : () =>  dispatch(actions.ON_LOAD_LOG_REPORT_VIEW.send()),
        onClear: () => dispatch(actions.ON_CLEAR_LOG_REPORT.call()),
        onFilterByType:(typeId) => dispatch(actions.ON_LOG_FILTER_BY_TYPE.call(typeId)),
        setFilteredAdvertisers: fRs => dispatch(actions.SET_FILTERED_ADVERTISERS.call(fRs)),
        clearFilteredAdvertisers: () => dispatch(actions.CLEAR_FILTERED_ADVERTISERS.call()),
        onRemoveFilm: (id) => dispatch(actions.ON_REMOVE_FILM_FROM_LOG_LIST.call(id)),
        onGeneratePdf: () => dispatch(actions.ON_GENERATE_LOG_PREVIEW_URL.call()),
        onShowComments: (showComments) => dispatch(actions.ON_SET_SHOW_COMMENTS.call(showComments))
    }))(LogReportV);

export const LogReportMessage = connect(
    (state) => ({
        advertisersCount: state.reportLog.advertisersCount,
        reportType: REPORT_TYPE.LOG,
        invalidFilmRelease: get(state.reportLog.logicError, "invalidFilmRelease", null),
        currentFilmRelease: get(state.reportLog, "filmRelease", null),
    }), (dispatch) => ({
        onClearError: () => dispatch(actions.ON_CLEAR_LOG_REPORT_ERROR.call()),
        onAcceptNewFilmRelease:() =>  dispatch(actions.ON_CLEAR_WITH_NEW_FILM_RELEASE_LOG.call())
    }))(AdvMessage);

export const ReportLogTable = connect((state) => ({
    advertisers: state.reportLog.advToReport,
    advertisementTypes: state.reportLog.advertisementTypes,
    reportType: REPORT_TYPE.LOG
}), (dispatch) => ({
    onFilterByType:(typeId) => dispatch(actions.ON_LOG_FILTER_BY_TYPE.call(typeId)),
    onRemoveFromReport:(adv) => dispatch(actions.ON_REMOVE_FROM_LOG_REPORT.call(adv))
}))(Table);

